/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var exit_popup = __webpack_require__(1);
	exit_popup.init();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    init: function init() {
	
	        (function ($) {
	            var bounceRecorded = false;
	            function createCookie(name, value, hours) {
	                if (hours) {
	                    var date = new Date();
	                    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
	                    var expires = "; expires=" + date.toGMTString();
	                } else var expires = "";
	                document.cookie = name + "=" + value + expires + "; path=/";
	            }
	
	            function readCookie(name) {
	                var nameEQ = name + "=";
	                var ca = document.cookie.split(';');
	                for (var i = 0; i < ca.length; i++) {
	                    var c = ca[i];
	                    while (c.charAt(0) == ' ') {
	                        c = c.substring(1, c.length);
	                    }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	                }
	                return null;
	            }
	
	            if (readCookie('fpBounceFired')) {
	                return;
	            }
	
	            $('#fp-bounce-ads .fp-bounce-ad-article').click(function () {
	                if (window.ga) {
	                    ga('send', 'event', 'Exit Popup', 'click on popup content recommendation', undefined, undefined, { nonInteraction: true });
	                }
	            });
	
	            var bouncePopup = $('#fp_bounce_popup');
	
	            $('#fp-bounce-header-close', bouncePopup).click(function (event) {
	                event.stopPropagation();
	                event.preventDefault();
	
	                $('#fp-bounce-unit', bouncePopup).addClass('fp-bounce-spring-loaded');
	
	                setTimeout(function () {
	                    bouncePopup.hide();
	                }, 400);
	            });
	
	            var openBouncePopup = function openBouncePopup() {
	                if (bounceRecorded || readCookie('fpBounceFired')) return;
	
	                bounceRecorded = true;
	
	                var recommendationItemsSelector = '#fp-bounce-ads .fp-bounce-ad-article';
	
	                createCookie('fpBounceFired', 1, 1);
	
	                $(recommendationItemsSelector, bouncePopup).addClass('fp-bounce-spring-loaded');
	
	                bouncePopup.show();
	
	                if (window.ga) {
	                    ga('send', 'event', 'Exit Popup', 'popup fired', undefined, undefined, { nonInteraction: true });
	                }
	
	                $('#fp-bounce-unit', bouncePopup).removeClass('fp-bounce-spring-loaded');
	
	                $(recommendationItemsSelector, bouncePopup).each(function (index) {
	                    var self = this;
	                    setTimeout(function () {
	                        $(self).removeClass('fp-bounce-spring-loaded');
	                    }, index * 100);
	                });
	            };
	
	            $('html').on('mouseleave', openBouncePopup);
	        })(window.jQuery);
	    }
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// fp-pause-helper.min.js